export default __webpack_public_path__ + "static/teamsImg3-93abcdd3fc1881426d5bcce6b48e7674.webp";